<template>
  <div class="cont-404 unselect">
    <div class="cont-in">
      <div class="img">
        <img src="@/assets/404@2x.png" alt="">
      </div>
      <div class="info">
        <div class="name">页面被火星人劫持了</div>
        <p class="title">更多惊喜值得期待</p>
        <router-link to="/home" class="btn">返回首页</router-link>
        <!-- <el-button type="primary" @click="navClick()">返回首页</el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  methods: {
    navClick (obj = {id: '0', name: '首页', url: '/'}) {
      this.$store.commit('addTab', obj)
    },
  }
}
</script>

<style lang="scss" scoped type="text/css">
.cont-404{
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  box-sizing: border-box;
  background:rgba(240,242,245,1);
  padding: 40px;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  z-index: 999;
}
.cont-in{
  width: 868px;
  margin: 0 auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.img{
  flex: 10;
}
.img img{
  display: block;
  height: 340px;
  width: 443px;
}
.info{

}
.info .name{
  height:38px;
  font-size:38px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(67,78,89,1);
  line-height:38px;
  margin-bottom: 20px;
}
.info .title{
  height:28px;
  font-size:20px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(0,0,0,0.45);
  line-height:28px;
  margin-bottom: 20px;
}
.info .btn{
  display: block;
  width:88px;
  height:32px;
  background:rgba(24,144,255,1);
  border-radius:4px;
  text-align: center;
  font-size:14px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(255,255,255,1);
  line-height:32px;
  cursor: pointer;
}
.info .btn:hover{
  box-shadow: 0 1px 5px rgba(24,144,255,1);
}
</style>

